import { Injector } from '@angular/core';
import { AbstractDragHandler2D } from '../../shared/tools/shared/drag-handlers/abstract-drag-handler-2d';
import { ImageContentStore } from '../state/image-content-store';

export abstract class AbstractRasterDragHandler extends AbstractDragHandler2D {
  protected override event = { id: 'paint_raster', bucket: 'annotation' };
  protected override shouldTrackBatchEvents = true;
  protected override store: ImageContentStore;

  constructor(
    protected code: number,
    initialEvent: MouseEvent,
    injector: Injector,
  ) {
    super(initialEvent, injector);
    this.store = injector.get(ImageContentStore);
  }
}
